<template>
  <div class="step1-container">
    <h2 style="margin: 20px 0">实验对象设置</h2>

    <FormItem
      label="功能点："
      prop="experimentCapability"
      :rules="[{ required: true, message: '请选择功能点', trigger: 'change' }]"
    >
      <Select
        :disabled="!!formData.experimentStatus || readonly"
        style="width: 300px"
        placeholder="选择功能点"
        v-model="formData.experimentCapability"
        @on-change="handleCapabilityChange"
      >
        <Option
          v-for="(item, index) in options.capabilitieList"
          :key="index"
          :value="String(item.code)"
          :disabled="isCapabilityDisabled(item.code)"
        >
          {{ item.desc }}
        </Option>
      </Select>
    </FormItem>

    <div v-if="formData.experimentCapability">
      <LegacyExperimentTargetFields
        v-if="isLegacySelected"
        :readonly="readonly"
        :formData="formData"
      />
      <ExperimentTargetFields
        v-else
        :readonly="readonly"
        :formData="formData"
      />
    </div>
  </div>
</template>

<script>
import {
  isLegacyCapability,
  isThirdPayCapability,
  toCapabilityCode
} from '../helpers'
import ExperimentTargetFields from './ExperimentTargetFields.vue'
import LegacyExperimentTargetFields from './LegacyExperimentTargetFields.vue'

export default {
  name: 'Step1',
  components: {
    ExperimentTargetFields,
    LegacyExperimentTargetFields
  },
  props: {
    options: {
      type: Object,
      default: () => ({
        capabilitieList: []
      })
    },
    readonly: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({
        groups: []
      })
    }
  },
  computed: {
    currentCapabilityCode() {
      return toCapabilityCode(this.formData.experimentCapability)
    },
    isLegacySelected() {
      return isLegacyCapability(this.currentCapabilityCode)
    }
  },
  methods: {
    ensureArrayField(key) {
      if (!Array.isArray(this.formData[key])) {
        this.$set(this.formData, key, [])
      }
    },
    handleCapabilityChange(value) {
      this.prepareFormByCapability(value)
      this.$emit('featureSelected', value)
    },
    isCapabilityDisabled(code) {
      return ['0', '1', '2', '5', '9'].includes(toCapabilityCode(code))
    },
    prepareFormByCapability(value) {
      const capabilityCode = toCapabilityCode(value)

      this.ensureArrayField('playIds')

      if (isLegacyCapability(capabilityCode)) {
        this.$set(this.formData, 'crowdMode', 'all')
        this.$set(this.formData, 'crowdIds', [])
        this.$set(this.formData, 'crowdCountryCodes', [])
        this.ensureArrayField('countries')
        this.ensureArrayField('linkChannel')
        if (
          this.formData.playIdsUnlimited !== 0 &&
          this.formData.playIdsUnlimited !== 1
        ) {
          this.$set(this.formData, 'playIdsUnlimited', '')
        }
        return
      }

      this.$set(this.formData, 'deviceSys', '')
      this.$set(this.formData, 'countriesUnlimited', '')
      this.$set(this.formData, 'countries', [])
      this.$set(this.formData, 'linkChannel', [])
      this.ensureArrayField('crowdIds')
      this.ensureArrayField('crowdCountryCodes')

      if (isThirdPayCapability(capabilityCode)) {
        this.$set(this.formData, 'playIdsUnlimited', '')
        this.$set(this.formData, 'playIds', [])
        this.$set(this.formData, 'crowdMode', 'selected')
        this.$set(this.formData, 'crowdType', 0)
        return
      }

      this.$set(
        this.formData,
        'crowdMode',
        this.formData.crowdIds.length ? 'selected' : 'all'
      )
      if (
        this.formData.playIdsUnlimited !== 0 &&
        this.formData.playIdsUnlimited !== 1
      ) {
        this.$set(this.formData, 'playIdsUnlimited', '')
      }
    }
  }
}
</script>

<style scoped lang="less">
.step1-container {
  padding: 20px;
  padding-bottom: 0;
}
</style>
